/**
 * @returns {?HTMLElement}
 */
const findShopifyFormsEmbed = () => {
  const formEmbed = document.querySelector('shopify-forms-embed');
  if (!formEmbed) {
    console.log('[Shopify Forms Prefill] No shopify-forms-embed element found');
    return null;
  }

  return formEmbed;
};

/**
 * @param {HTMLElement} formEmbed - The shopify-forms-embed element
 * @returns {?ShadowRoot}
 */
const getShadowRoot = (formEmbed) => {
  const shadowRoot = formEmbed.shadowRoot;
  if (!shadowRoot) {
    console.log('[Shopify Forms Prefill] No shadow root found');
    return null;
  }

  return shadowRoot;
};

/**
 * @param {ShadowRoot} shadowRoot - The shadow root to search in
 * @param {string} selector - CSS selector string
 * @returns {?HTMLElement}
 */
const selectFromShadowRoot = (shadowRoot, selector) => {
  const element = shadowRoot.querySelector(selector);
  if (!element) {
    console.log(`[Shopify Forms Prefill] Element not found with selector: ${selector}`);
    return null;
  }

  return element;
};

/**
 * @param {HTMLElement} element - The element to click
 */
const clickWithoutFocus = (element) => {
  const scrollX = window.scrollX;
  const scrollY = window.scrollY;

  element.click();

  const restoreScroll = () => {
    window.scrollTo(scrollX, scrollY);
  };

  /**
   * By clicking the element Shopify automatically scrolls to them.
   * Since we don't want the user to know we did a prefill this resets the scroll position.
   * We also added a loader to prevent the page from flashing.
   */
  restoreScroll();
  requestAnimationFrame(() => {
    restoreScroll();
    setTimeout(restoreScroll, 0);
    setTimeout(restoreScroll, 10);
    setTimeout(restoreScroll, 50);
  });
};

/**
 * @param {NodeListOf<Element>} options - The option elements to search
 * @param {string} targetValue - The value to match against innerHTML
 * @returns {boolean}
 */
const selectMatchingOption = (options, targetValue) => {
  const matchingOption = Array.from(options).find((option) => {
    return option.textContent === targetValue;
  });

  if (!matchingOption) {
    console.log(`[Shopify Forms Prefill] No option found matching: ${targetValue}`);
    return false;
  }

  clickWithoutFocus(matchingOption);
  return true;
};

/**
 * @param {string} paramName - The name of the URL parameter to retrieve
 * @returns {?string}
 */
const getUrlParameter = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(paramName);
  if (!value) {
    console.log(`[Shopify Forms Prefill] No URL parameter found for: ${paramName}`);
    return null;
  }

  return value;
};
/**
 * @param {HTMLElement} formEmbed - The form embed element
 */
const hideLoaderAndShowForm = (formEmbed) => {
  const loader = document.querySelector('.shopify-forms-prefill-loader');
  if (loader) {
    loader.classList.add('hidden');
  }
  formEmbed.classList.add('shopify-forms-prefill-visible');
};

/**
 * @param {?string} targetValue - The value to select from the dropdown
 */
const prefillShopifyFormsSelect = (targetValue) => {
  const formEmbed = findShopifyFormsEmbed();
  if (!formEmbed) {
    console.log(`[Shopify Forms Prefill] No form embed found`);
    return;
  }

  if (!targetValue) {
    console.log(`[Shopify Forms Prefill] No target value, hiding loader and showing form`);
    hideLoaderAndShowForm(formEmbed);
    return;
  }

  const shadowRoot = getShadowRoot(formEmbed);
  if (!shadowRoot) {
    console.log(`[Shopify Forms Prefill] No shadow root found, hiding loader and showing form`);
    hideLoaderAndShowForm(formEmbed);
    return;
  }

  console.log(`[Shopify Forms Prefill] Starting prefill with value: ${targetValue}`);

  const selectToggle = selectFromShadowRoot(
    shadowRoot,
    'form > ._selectContainer_12thd_6 ._selectToggle_12thd_25'
  );
  if (!selectToggle) {
    hideLoaderAndShowForm(formEmbed);
    return;
  }

  clickWithoutFocus(selectToggle);

  setTimeout(() => {
    const options = shadowRoot.querySelectorAll('form > ._selectContainer_12thd_6 ._optionListItem_12thd_102 > div');
    if (options.length === 0) {
      console.log('[Shopify Forms Prefill] No options found');
      hideLoaderAndShowForm(formEmbed);
      return;
    }

    selectMatchingOption(options, targetValue);

    hideLoaderAndShowForm(formEmbed);
  }, 1000);
};

const initPrefill = () => {
  setTimeout(() => {
    prefillShopifyFormsSelect(getUrlParameter('function'));
  }, 2000); // Making sure the Shopify form embed is loaded
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPrefill);
} else {
  initPrefill();
}
